// src/components/dashboard/Donor/DonorDashboard.jsx
import React , {useState, useEffect} from 'react';
import Navbar from '../Navbar'; // Adjust the import path if necessary
import DonorSidebar from './donorSidebar';
import Footer from '../Footer'; // Adjust the import path if necessary
import DashboardCards from '../dashboardCards/dashboardCards';
import { handleAPIRequest } from '../../../api/api';
import PriceButton from '../priceButtons';
import { useSelector } from "react-redux";
import TaxCalculator from '../tax-calculator/taxCalculator';
const DonorDashboard = () => {
  const token = useSelector((state) => state.auth.token);
  const membershipStatus = useSelector((state) => state.auth.membershipStatus);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [dashboardData, setDashboardData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await handleAPIRequest("get", "get-countD", null, null, token);
        const data = [
          { title: "Total Tenders Registered", count: response.tt,link: "/dashboard/donor/tenders" },
          { title: "Total Active Tenders", count: response.at,link: "/dashboard/donor/tenders" },
          { title: "Total NGOs Registered", count: response.nu,link: "/dashboard/donor/ngos" },
          { title: "Total Closed Tenders", count: response.ct,link: "/dashboard/donor/tenders" },
        ];
        setDashboardData(data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="flex min-h-screen">
      <DonorSidebar  isOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
      <div className="flex-1 flex flex-col">
      <Navbar toggleSidebar={toggleSidebar}/>
        <main className="flex-grow p-6">
          <h2 className="text-2xl font-bold mb-4">Donor Dashboard</h2>
            {/* Membership Expired Message */}
            {membershipStatus === 'inactive' && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6">
              <strong className="font-bold">Dear Valued Donor,</strong>
              <p className="mt-1">
                Your membership plan is currently <span className="font-semibold">inactive</span>. 
                To continue accessing the platform's features, please renew your membership 
                or contact support. Thank you!
              </p>
            </div>
          )}
          <p className="mb-6">Welcome to the Donor Dashboard! Manage your donor details, tenders, and bids here.</p>

          <DashboardCards  data={dashboardData} />

           {membershipStatus !== 'inactive' && (
            <div>
            <TaxCalculator/>
            <PriceButton />
            </div>
          )}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default DonorDashboard;
